import { makeVar, useReactiveVar } from '@/utility/reactiveVariable';

import { ActiveOptimizelyDecision, ENABLED_VARIATION_KEY } from './index';

// Update this reactive variable when the decision is made when we want to share it.
export const listing20Decision = makeVar<ActiveOptimizelyDecision | null>(null);

// We need to access this decision in some common components, like header, but we don't want
// to bucket users that don't visit checkout pages. Use this hook so we can read the decision
// in other components without also bucket triggering.
export const useListing20IsEnabled = () => {
  return useReactiveVar(listing20Decision)?.variationKey === ENABLED_VARIATION_KEY;
};
